import { render, staticRenderFns } from "./porposal-confirmation.vue?vue&type=template&id=37816e3f&scoped=true&"
import script from "./porposal-confirmation.vue?vue&type=script&lang=ts&"
export * from "./porposal-confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./porposal-confirmation.vue?vue&type=style&index=0&id=37816e3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37816e3f",
  null
  
)

export default component.exports